module.exports = __webpack_public_path__ + "static/join-192e2e00b1fe1246a091fb462abf7bea.webp";